import { From, MessageType, TextPayloadInterface, TypingPayloadActionType } from "@swivl-mono/types";
import anchorme from "anchorme";
import { findPhoneNumbersInText } from "libphonenumber-js";

import { ListItemData } from "../ListItem/ListItem";

function spliceSplit(str: string, index: number, count: number, add: string): string {
  var ar = str.split("");
  ar.splice(index, count, add);
  return ar.join("");
}

export function addPhoneNumberAndURLLinksForMessage(item: ListItemData): ListItemData {
  if (item.message) {
    if (item.message.type !== MessageType.Text) {
      return item;
    }

    let payload = item.message.payload as TextPayloadInterface;
    if (payload && (payload as any).text) {
      const urlList = anchorme.list((payload as any).text); // NOTE: We need to first check to see if it has any urls because if it does, we need to mark the message as having html
      if (urlList && urlList.length > 0) {
        item.isHTML = true;
        if (payload.openLinksInNewTab) {
          payload.text = anchorme({ input: payload.text, options: { attributes: { target: "_blank" } } });
        } else {
          payload.text = anchorme({ input: payload.text, options: { attributes: { target: "_parent" } } });
        }
      }

      const numbers = findPhoneNumbersInText(payload.text, "US");
      if (numbers && numbers.length > 0) {
        for (var i = numbers.length - 1; i >= 0; i--) {
          if (numbers[i].startsAt && numbers[i].endsAt && numbers[i].number && numbers[i].number.number) {
            item.isHTML = true;
            payload.text = spliceSplit(
              payload.text,
              numbers[i].startsAt,
              numbers[i].endsAt - numbers[i].startsAt,
              '<a href="tel:' + numbers[i].number.number + '">' + numbers[i].number.formatNational() + "</a>"
            );
          }
        }
      }
      item.message.payload = payload;

      return item;
    }
  }

  return item;
}

/**
 * Rules for cleanup:
 * if
 * BOT USER
 * TYPE BUTTONS - IF THERE ARE NO USER MESSAGES AFTER IT IT IS ACTIVE.
 * TYPE TYPING INDICATOR - IF THERE ARE NO BOT MESSAGES OF ANY TYPE AFTER IT, IT IS ACTIVE
 *
 * @param  {[type]} items [description]
 * @return {[type]}       [description]
 */
export function cleanUpList(items: Array<ListItemData>): Array<ListItemData> {
  let botUserItem: any = null;
  let botItem: any = null;

  for (let i = 0; i < items.length; i++) {
    let item = items[i];

    if (item.sender === From.USER) {
      if (!botUserItem && item.message.type === MessageType.Text) {
        botUserItem = item;
        items[i].isActive = true;
      } else {
        items[i].isActive = false;
      }
    } else {
      if (
        !botItem &&
        (item.message.type === MessageType.Text ||
          item.message.type === MessageType.Media ||
          (item.message.type === MessageType.Carousel && !botUserItem) ||
          (item.message.type === MessageType.LocationPicker && !botUserItem) ||
          (item.message.type === MessageType.SpacePicker && !botUserItem) ||
          (item.message.type === MessageType.ProfileCollect && !botUserItem) ||
          (item.message.type === MessageType.Typing && (item.message.payload as any).action === TypingPayloadActionType.Started) ||
          (item.message.type === MessageType.Buttons && !botUserItem))
      ) {
        botItem = item;
        items[i].isActive = true;
      } else {
        items[i].isActive = false;
      }
    }
  }
  return items;
}
